import React, { useEffect, useState, useCallback, useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory } from 'react-router-dom';

import { Button, CircularProgress, IconButton, SvgIcon } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';

import { post } from '../../../../../_axios/requisicao';

import { Container, Content, Toolbar } from '../../../../../componentes/Interface';
import Spinner from '../../../../../componentes/Spinner';
import FormCupom from '../../../../../componentes/FormCupom';

import Toast from '../../../../../componentes/Toast';
import {
  TEXTO_SPINNER_CPF,
  TEXTO_SPINNER_INSCRICAO,
  TEXTO_CPF_INVALIDO,
  TEXTO_SERVER_ERROR,
  TEXTO_NAO_PERMITE_INSCRICAO,
} from '../textos';

import { InscricaoEFLContext } from '../../..';
import { BotaoCupom } from './styles';
import { IStoreRedux } from 'Types/Reducers';

function MultiEtapas() {
  const { etapas, schema, validaHashEvento, lote } = useContext(InscricaoEFLContext);

  const { location } = useHistory();

  const etapaAtual = useMemo(() => {
    const etapaSelecionada = etapas.find((etapa, index) => {
      if (etapa.path === location.pathname) {
        etapa.posicao = index;
        return true;
      }

      return false;
    });

    if (etapaSelecionada && Object.keys(etapaSelecionada).length)
      return etapaSelecionada;

    return { posicao: 0, ...etapas[0] };
  }, [etapas, location.pathname]);

  const dispatch = useDispatch();
  const stateApp = useSelector((state: IStoreRedux) => state.app);
  const dados = useSelector((state: IStoreRedux) => state.dados);
  const contatos = useSelector((state: IStoreRedux) => state.contatos);
  const endereco = useSelector((state: IStoreRedux) => state.endereco);
  const termos = useSelector((state: IStoreRedux) => state.termos);

  const historicoNavegacao = useHistory();

  const [posicaoEtapaAtual, setPosicaoEtapaAtual] = useState<number>(0);
  const [spinner, setSpinner] = useState<boolean>(false);
  const [mesangemSpinner, setMensagemSpinner] = useState<JSX.Element>(<></>);
  const [exibeMensagemErro, setExibeMensagemErro] = useState<boolean>(false);
  const [mensagemErro, setMensagemErro] = useState<string>('');

  const verificaCpf = useCallback(async () => {
    setMensagemSpinner(TEXTO_SPINNER_CPF);
    setSpinner(true);

    try {
      const valido = await validaHashEvento({ cpf: dados.cpf });

      if (valido) {
        setSpinner(false);
        setExibeMensagemErro(false);

        // reutilizar o pedidoOdoo salvo (ver validaHashEvento)
        // if (valido.pedidoOdoo) {
        //   setPedidoOdoo(valido.pedidoOdoo);
        //   setAbreCheckout(true);
        //   setMensagemSpinner(TEXTO_SPINNER_PAGAMENTO_PENDENTE);
        //   setSpinner(true);
        //   return true;
        // }

        if (!valido.permiteInscricao) {
          setMensagemErro(TEXTO_NAO_PERMITE_INSCRICAO);
          setExibeMensagemErro(true);
          return false;
        }

        historicoNavegacao.push(etapas[posicaoEtapaAtual + 1].path);
        return true;
      } else {
        setSpinner(false);
        setMensagemErro(TEXTO_CPF_INVALIDO);
        setExibeMensagemErro(true);
        return false;
      }

    } catch (error) {
      console.error(error)
      setSpinner(false);
      setMensagemErro(TEXTO_CPF_INVALIDO);
      setExibeMensagemErro(true);
      return false;
    }
  }, [dados.cpf, etapas, historicoNavegacao, posicaoEtapaAtual, validaHashEvento]);

  const inscreveAluno = useCallback(async () => {
    const uriInscricaoAluno = '/inscricoes';
    const inscricao = {
      dados,
      contatos,
      endereco,
      termos,
      cupom: stateApp.cupom,
      hashEvento: stateApp.hash,
      lote: Number(lote),
    };

    const header = {
      referencia: stateApp.referencia,
      usuario: stateApp.idUsuario || '',
      responsavel: dados.visitadoporid || '',
      schema,
    }
    setMensagemSpinner(TEXTO_SPINNER_INSCRICAO);
    setSpinner(true);

    try {
      const retorno = await post('api-pessoas', uriInscricaoAluno, inscricao, header);
      if (retorno) {
        setSpinner(false);
        setExibeMensagemErro(false);

        dispatch({ type: 'ALTERA_IDPESSOA', idPessoa: retorno.data.dados.idconvidado });
        dispatch({ type: 'ALTERA_STATUS', status: 'pagamento-andamento' });
        return retorno.data.pedidoOdoo;
      } else {
        setMensagemErro(TEXTO_SERVER_ERROR);
        setExibeMensagemErro(true);
        setSpinner(false);
        return false;
      }

    } catch (error) {
      console.error(error);
      setMensagemErro(TEXTO_SERVER_ERROR);
      setExibeMensagemErro(true);
      setSpinner(false);
      return false;
    }
  }, [lote,
    dados,
    contatos,
    endereco,
    termos,
    stateApp.cupom,
    stateApp.hash,
    stateApp.referencia,
    stateApp.idUsuario,
    schema,
    dispatch,
  ]);

  const navegaParaEtapaSeguinte = useCallback(async () => {
    const uriCPF = '/convite-publico/formulario/dados/cpf';
    const uriTermo = '/convite-publico/formulario/termo-adesao';
    let resultadoValidaCPF: boolean | undefined = false;


    if (posicaoEtapaAtual === etapas.length - 1) return;

    const posicaoEtapa = (posicaoEtapaAtual + 1);
    const urlDestino = etapas[posicaoEtapa].path;

    const etapaAtualPath = etapas[posicaoEtapaAtual].path;

    if (etapaAtualPath === uriCPF) {
      resultadoValidaCPF = await verificaCpf();
      if(!resultadoValidaCPF)
        return;
    } else if (etapaAtualPath === uriTermo) {
      const pedidoOdoo = await inscreveAluno();

      if (pedidoOdoo) {
        setSpinner(true);
        dispatch({ type: 'ALTERA_PEDIDO_ODOO', pedidoOdoo });
        return window.location.replace(pedidoOdoo.checkout);
      } else if (!pedidoOdoo) {
        setMensagemErro(TEXTO_SERVER_ERROR);
        setExibeMensagemErro(true);
        return;
      }
    }

    historicoNavegacao.push(urlDestino);
    setPosicaoEtapaAtual(posicaoEtapa);
    setExibeMensagemErro(false);
  }, [dispatch, etapas, historicoNavegacao, inscreveAluno, posicaoEtapaAtual, verificaCpf]);

  const navegaParaEtapaAnterior = useCallback(() => {
    if (posicaoEtapaAtual <= 0) return;
    const posicaoEtapa = (posicaoEtapaAtual - 1);
    setPosicaoEtapaAtual(posicaoEtapa);
    const etapaAnterior = etapas.filter((etapa: any, index: any) => index === posicaoEtapa);

    historicoNavegacao.push(etapaAnterior[0].path);
  }, [etapas, historicoNavegacao, posicaoEtapaAtual]);

  useEffect(() => {
    if(stateApp.inscrito) {
      historicoNavegacao.push('/convite-publico/confirmacao');
    }

    setPosicaoEtapaAtual(etapaAtual.posicao ?? 0);
    dispatch({ type: `ALTERA_CARREGANDO`, carregando: false });
  }, [dispatch, etapaAtual.posicao, historicoNavegacao, stateApp.inscrito]);

  const rotasDeEtapas = useMemo(() => (
    <Switch>
      {
        etapas.map(etapa =>
          <Route path={etapa.path} exact>
            {etapa.component}
          </Route>
        )
      }
    </Switch>
  ), [etapas]);

  return (
    <Container>
      {spinner && <Spinner texto={mesangemSpinner}/>}

      {/* Toolbar */}
      <Content>
        <Toolbar>
          {posicaoEtapaAtual > 0 &&
            <IconButton onClick={navegaParaEtapaAnterior}>
              <ArrowBack />
            </IconButton>
          }
          {stateApp.carregando && <CircularProgress color='primary' size={24}/>}
        </Toolbar>
      </Content>
      <Content full padding pb="3rem">
        {/* Campo do Input */}
        {rotasDeEtapas}
        <br/><br/>



        <Button
          disabled={stateApp.etapaValida !== true}
          size='large'
          variant='contained'
          color='primary'
          onClick={navegaParaEtapaSeguinte}
        >
          {etapaAtual.path.includes('termo-adesao') ? 'Aceitar e Continuar' : 'Continuar'}
        </Button>

        {/* Cupom */}
        <FormCupom>
          <BotaoCupom variant="contained">
            <SvgIcon viewBox="0 0 512 512">
              <g><g><path d="M477.958,262.633c-2.06-4.215-2.06-9.049,0-13.263l19.096-39.065c10.632-21.751,2.208-47.676-19.178-59.023l-38.41-20.38    c-4.144-2.198-6.985-6.11-7.796-10.729l-7.512-42.829c-4.183-23.846-26.241-39.87-50.208-36.479l-43.053,6.09    c-4.647,0.656-9.242-0.838-12.613-4.099l-31.251-30.232c-17.401-16.834-44.661-16.835-62.061,0L193.72,42.859    c-3.372,3.262-7.967,4.753-12.613,4.099l-43.053-6.09c-23.975-3.393-46.025,12.633-50.208,36.479l-7.512,42.827    c-0.811,4.62-3.652,8.531-7.795,10.73l-38.41,20.38c-21.386,11.346-29.81,37.273-19.178,59.024l19.095,39.064    c2.06,4.215,2.06,9.049,0,13.263l-19.096,39.064c-10.632,21.751-2.208,47.676,19.178,59.023l38.41,20.38    c4.144,2.198,6.985,6.11,7.796,10.729l7.512,42.829c3.808,21.708,22.422,36.932,43.815,36.93c2.107,0,4.245-0.148,6.394-0.452    l43.053-6.09c4.643-0.659,9.241,0.838,12.613,4.099l31.251,30.232c8.702,8.418,19.864,12.626,31.03,12.625    c11.163-0.001,22.332-4.209,31.03-12.625l31.252-30.232c3.372-3.261,7.968-4.751,12.613-4.099l43.053,6.09    c23.978,3.392,46.025-12.633,50.208-36.479l7.513-42.827c0.811-4.62,3.652-8.531,7.795-10.73l38.41-20.38    c21.386-11.346,29.81-37.273,19.178-59.024L477.958,262.633z M464.035,334.635l-38.41,20.38    c-12.246,6.499-20.645,18.057-23.04,31.713l-7.512,42.828c-1.415,8.068-8.874,13.487-16.987,12.342l-43.053-6.09    c-13.73-1.945-27.316,2.474-37.281,12.113L266.5,478.152c-5.886,5.694-15.109,5.694-20.997,0l-31.251-30.232    c-8.422-8.147-19.432-12.562-30.926-12.562c-2.106,0-4.229,0.148-6.355,0.449l-43.053,6.09    c-8.106,1.146-15.571-4.274-16.987-12.342l-7.513-42.829c-2.396-13.656-10.794-25.215-23.041-31.712l-38.41-20.38    c-7.236-3.839-10.086-12.61-6.489-19.969l19.096-39.065c6.088-12.456,6.088-26.742,0-39.198l-19.096-39.065    c-3.597-7.359-0.747-16.13,6.489-19.969l38.41-20.38c12.246-6.499,20.645-18.057,23.04-31.713l7.512-42.828    c1.416-8.068,8.874-13.488,16.987-12.342l43.053,6.09c13.725,1.943,27.316-2.474,37.281-12.113l31.252-30.232    c5.886-5.694,15.109-5.694,20.997,0l31.251,30.232c9.965,9.64,23.554,14.056,37.281,12.113l43.053-6.09    c8.107-1.147,15.572,4.274,16.987,12.342l7.512,42.829c2.396,13.656,10.794,25.215,23.041,31.712l38.41,20.38    c7.236,3.839,10.086,12.61,6.489,19.969l-19.096,39.064c-6.088,12.455-6.088,26.743,0,39.198l19.096,39.064    C474.121,322.024,471.271,330.796,464.035,334.635z"/></g></g>
              <g><g><path d="M363.886,148.116c-5.765-5.766-15.115-5.766-20.881,0L148.116,343.006c-5.766,5.766-5.766,15.115,0,20.881    c2.883,2.883,6.662,4.325,10.44,4.325c3.778,0,7.558-1.441,10.44-4.325l194.889-194.889    C369.653,163.231,369.653,153.883,363.886,148.116z"/></g></g>
              <g><g><path d="M196.941,123.116c-29.852,0-54.139,24.287-54.139,54.139s24.287,54.139,54.139,54.139s54.139-24.287,54.139-54.139    S226.793,123.116,196.941,123.116z M196.941,201.863c-13.569,0-24.608-11.039-24.608-24.609c0-13.569,11.039-24.608,24.608-24.608    c13.569,0,24.609,11.039,24.609,24.608C221.549,190.824,210.51,201.863,196.941,201.863z"/></g></g>
              <g><g><path d="M315.061,280.61c-29.852,0-54.139,24.287-54.139,54.139s24.287,54.139,54.139,54.139    c29.852,0,54.139-24.287,54.139-54.139S344.913,280.61,315.061,280.61z M315.061,359.357c-13.569,0-24.609-11.039-24.609-24.608    s11.039-24.608,24.609-24.608c13.569,0,24.608,11.039,24.608,24.608S328.63,359.357,315.061,359.357z"/></g></g>
            </SvgIcon>
            Adicionar Cupom
          </BotaoCupom>
        </FormCupom>

        <Toast
          exibe={exibeMensagemErro}
          setExibe={setExibeMensagemErro}
          mensagem={mensagemErro}
          duration={10000}
          botao
        />
      </Content>
    </Container>
  )
}

export default MultiEtapas;